"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const remove_protocol_1 = require("./maps/remove_protocol");
const to_blank_string_1 = require("./maps/to_blank_string");
const even_odd_split_1 = require("./utilities/even_odd_split");
const url_transformer_1 = require("./utilities/url_transformer");
exports.urlRedirectStripTokens = url_transformer_1.default(even_odd_split_1.evenOddSplit(remove_protocol_1.default, to_blank_string_1.default));
exports.default = exports.urlRedirectStripTokens;
//# sourceMappingURL=url_redirect_strip_tokens.js.map